import { Injectable } from '@angular/core';
import { Log } from '@shared/debug/log';
import { Subject } from 'rxjs';
import { LoadedProjectData } from './loaded-project.data';
import { ComplexProjectVO } from '../model/vo/project.vo';

@Injectable({ providedIn: 'root' })
export class LoadProjectInfoService {

  private _isLoading = false;

  public get isLoading() {
    return this._isLoading;
  }

  public set isLoading(value: boolean) {
    this._isLoading = value;
  }

  private _projectLoaded = new Subject<LoadedProjectData>();

  public get projectLoaded$() {
    return this._projectLoaded.asObservable();
  }

  public projectLoadedSuccess(complexProject: ComplexProjectVO): LoadedProjectData {
    const loadedProjectData: LoadedProjectData = {success: true, complexProject: complexProject};
    this._projectLoaded.next(loadedProjectData);
    return loadedProjectData;
  }

  public projectLoadedError(error: any): LoadedProjectData {
    Log.error(error);
    const loadedProjectData: LoadedProjectData = {success: false, error: error};
    this._projectLoaded.next(loadedProjectData);
    return loadedProjectData;
  }
}
